/**
 * Stable lesson codes for मेरे पाठ · My readings topics.
 * IDs are semantic and do not change when syllabus order or display numbers shift.
 * Legacy `my-observations-pause-NN` URLs map here via jyotishaTopicCanonical.js.
 */

/** @typedef {{ id: string; legacyId: string; lessonCode: string; hi: string; en: string; titleHi: string; titleEn: string; taglineHi: string; taglineEn: string; image?: string; imageAltHi?: string; imageAltEn?: string }} MyReadingsTopic */

/** @type {MyReadingsTopic[]} */
export const MY_READINGS_TOPICS = [
  {
    id: 'my-readings-rahu-desire',
    legacyId: 'my-observations-pause-01',
    hi: 'राहु और इच्छा',
    en: 'Rahu and desire',
    titleHi: 'राहु और इच्छा',
    titleEn: 'Rahu and desire',
    taglineHi: 'पढ़ाई के नोट्स - गहरी बातें, रोज़मर्रा के शब्द।',
    taglineEn: 'Reading notes - deep ideas in everyday words.',
    image: '/schools/parashari/devta/rahu.png',
    imageAltHi: 'राहु का चित्र',
    imageAltEn: 'Illustration of Rahu',
  },
  {
    id: 'my-readings-retrograde-reality',
    legacyId: 'my-observations-pause-02',
    hi: 'वक्री वास्तविकता जांच',
    en: 'Retrograde reality check',
    titleHi: 'वक्री ग्रह - असली तस्वीर',
    titleEn: 'Retrograde planets - what actually shifts',
    taglineHi: 'वक्री = सिर्फ “नीच” नहीं। समय और तरीका बदल सकता है।',
    taglineEn: 'Retrograde isn’t just “weak.” Timing and delivery can shift.',
    image: '/schools/parashari/hd/retrogade.png',
    imageAltHi: 'वक्री ग्रह का चित्र',
    imageAltEn: 'Illustration of a retrograde planet',
  },
  {
    id: 'my-readings-venus-mahadasha',
    legacyId: 'my-observations-pause-03',
    hi: 'शुक्र महादशा समीक्षा',
    en: 'Venus Mahadasha review',
    titleHi: 'शुक्र महादशा समीक्षा',
    titleEn: 'Venus Mahadasha review',
    taglineHi: 'शुक्र दशा - संबंध, आराम और कला कैसे पढ़ें।',
    taglineEn: 'Venus dasha - how to read love, comfort, and creativity.',
    image: '/schools/parashari/devta/venus.png',
    imageAltHi: 'शुक्र का चित्र',
    imageAltEn: 'Illustration of Venus',
  },
  {
    id: 'my-readings-headache-patterns',
    legacyId: 'my-observations-pause-04',
    hi: 'सिरदर्द पैटर्न नोट्स',
    en: 'Headache pattern notes',
    titleHi: 'सिरदर्द पैटर्न नोट्स',
    titleEn: 'Headache pattern notes',
    taglineHi: 'चंद्र, मंगल, राहु, तनाव - चार्ट में सिरदर्द के पैटर्न।',
    taglineEn: 'Moon, Mars, Rahu, stress - headache patterns in the chart.',
    image: '/schools/parashari/devta/moon.png',
    imageAltHi: 'चंद्र का चित्र',
    imageAltEn: 'Illustration of the Moon',
  },
  {
    id: 'my-readings-loans-emi-chart',
    legacyId: 'my-observations-pause-05',
    hi: 'ऋण, ईएमआई और चार्ट',
    en: 'Loans, EMI & chart',
    titleHi: 'ऋण, ईएमआई और चार्ट',
    titleEn: 'Loans, EMI & chart',
    taglineHi: '6, 8, 11 और 12वाँ भाव - ऋण के संकेत कहाँ दिखते हैं।',
    taglineEn: 'Houses 6, 8, 11, 12 - where debt signals show up.',
    image: '/schools/parashari/devta/saturn.png',
    imageAltHi: 'शनि का चित्र',
    imageAltEn: 'Illustration of Saturn',
  },
  {
    id: 'my-readings-nakshatra-remedy',
    legacyId: 'my-observations-pause-06',
    hi: 'नक्षत्र अनुसार एक उपाय',
    en: 'One remedy per nakshatra',
    titleHi: 'नक्षत्र अनुसार एक उपाय',
    titleEn: 'One remedy per nakshatra',
    taglineHi: '27 नक्षत्र - हर एक के लिए एक सरल उपाय और देवता संकेत।',
    taglineEn: '27 nakshatras - one simple remedy and deity note each.',
    image: '/schools/parashari/devta/moon.png',
    imageAltHi: 'नक्षत्र चक्र का चित्र',
    imageAltEn: 'Illustration of the nakshatra wheel',
  },
  {
    id: 'my-readings-graha-friendly-bhavas',
    legacyId: 'my-observations-pause-07',
    hi: 'ग्रह और अनुकूल भाव',
    en: 'Grahas & friendly bhavas',
    titleHi: 'ग्रह और अनुकूल भाव',
    titleEn: 'Grahas & friendly bhavas',
    taglineHi: 'कौन सा ग्रह किस भाव में सहज लगता है।',
    taglineEn: 'Which graha feels at home in which bhava.',
    image: '/schools/parashari/devta/jupiter.png',
    imageAltHi: 'ग्रह और भाव का चित्र',
    imageAltEn: 'Illustration of grahas and bhavas',
  },
  {
    id: 'my-readings-21-life-havans',
    legacyId: 'my-observations-pause-08',
    hi: '21 जीवन हवन',
    en: '21 life havans',
    titleHi: '21 जीवन हवन',
    titleEn: '21 life havans',
    taglineHi: '21 हवन-थीम - जीवन के क्षेत्र के हिसाब से साधना संकेत।',
    taglineEn: '21 havan themes mapped to areas of life.',
    image: '/schools/parashari/devta/sun.png',
    imageAltHi: 'हवन का चित्र',
    imageAltEn: 'Illustration of havan',
  },
  {
    id: 'my-readings-child-mantras',
    legacyId: 'my-observations-pause-09',
    hi: 'बच्चों के 11 मंत्र',
    en: '11 child mantras',
    titleHi: 'बच्चों के 11 मंत्र',
    titleEn: '11 child mantras',
    taglineHi: 'बच्चों के लिए सरल, सौम्य मंत्र-संकेत।',
    taglineEn: 'Simple, gentle mantra notes for children.',
    image: '/schools/parashari/devta/jupiter.png',
    imageAltHi: 'बच्चों के मंत्र का चित्र',
    imageAltEn: 'Illustration of child mantras',
  },
  {
    id: 'my-readings-habits-graha',
    legacyId: 'my-observations-pause-10',
    hi: 'आदतें और ग्रह संकेत',
    en: 'Habits & graha signals',
    titleHi: 'आदतें और ग्रह संकेत',
    titleEn: 'Habits & graha signals',
    taglineHi: 'रोज़ की आदतें किस ग्रह की भाषा बोलती हैं।',
    taglineEn: 'Daily habits as graha language.',
    image: '/schools/parashari/devta/mercury.png',
    imageAltHi: 'आदतों और ग्रह का चित्र',
    imageAltEn: 'Illustration of habits and grahas',
  },
  {
    id: 'my-readings-lal-kitab-21',
    legacyId: 'my-observations-pause-11',
    hi: '21 लाल किताब उपाय',
    en: '21 Lal Kitab remedies',
    titleHi: '21 लाल किताब उपाय',
    titleEn: '21 Lal Kitab remedies',
    taglineHi: 'लाल किताब शैली के 21 व्यावहारिक संकेत।',
    taglineEn: '21 practical Lal Kitab style notes.',
    image: '/schools/parashari/devta/mars.png',
    imageAltHi: 'लाल किताब का चित्र',
    imageAltEn: 'Illustration of Lal Kitab',
  },
  {
    id: 'my-readings-navagraha-sutras',
    legacyId: 'my-observations-pause-12',
    hi: '9 नवग्रह सूत्र',
    en: '9 Navagraha sutras',
    titleHi: '9 नवग्रह सूत्र',
    titleEn: '9 Navagraha sutras',
    taglineHi: 'नौ ग्रह - हर एक का एक संक्षिप्त सूत्र।',
    taglineEn: 'Nine grahas - one concise sutra each.',
    image: '/schools/parashari/devta/sun.png',
    imageAltHi: 'नवग्रह का चित्र',
    imageAltEn: 'Illustration of the navagraha',
  },
  {
    id: 'my-readings-moon-silent-goals',
    legacyId: 'my-observations-pause-13',
    hi: 'चंद्र · मौन लक्ष्य',
    en: 'Moon · goals in silence',
    titleHi: 'चंद्र · मौन लक्ष्य',
    titleEn: 'Moon · goals in silence',
    taglineHi: 'शांति में चंद्र अक्सर लक्ष्य साफ़ करता है।',
    taglineEn: 'In quiet practice, Moon often clarifies goals.',
    image: '/schools/parashari/devta/moon.png',
    imageAltHi: 'चंद्र का चित्र',
    imageAltEn: 'Illustration of the Moon',
  },
  {
    id: 'my-readings-brihat-jataka-secrets',
    legacyId: 'my-observations-pause-14',
    hi: 'बृहत् जातक · 11 रहस्य',
    en: 'Brihat Jataka · 11 secrets',
    titleHi: 'बृहत् जातक · 11 रहस्य',
    titleEn: 'Brihat Jataka · 11 secrets',
    taglineHi: 'बृहत् जातक से 11 पठन संकेत।',
    taglineEn: '11 reading clues from Brihat Jataka.',
    image: '/schools/parashari/devta/jupiter.png',
    imageAltHi: 'बृहत् जातक का चित्र',
    imageAltEn: 'Illustration of Brihat Jataka',
  },
  {
    id: 'my-readings-rahu-nakshatra',
    legacyId: 'my-observations-pause-15',
    hi: 'राहु प्रत्येक नक्षत्र में',
    en: 'Rahu in each Nakshatra',
    titleHi: 'राहु प्रत्येक नक्षत्र में',
    titleEn: 'Rahu in each nakshatra',
    taglineHi: '27 नक्षत्रों में राहु का रंग अलग-अलग।',
    taglineEn: 'Rahu colours each of the 27 nakshatras differently.',
    image: '/schools/parashari/devta/rahu.png',
    imageAltHi: 'राहु और नक्षत्र का चित्र',
    imageAltEn: 'Illustration of Rahu and nakshatras',
  },
  {
    id: 'my-readings-ketu-conjunctions',
    legacyId: 'my-observations-pause-16',
    hi: 'केतु की ग्रह युतियां',
    en: 'Ketu conjunct another planet',
    titleHi: 'केतु की ग्रह युतियां',
    titleEn: 'Ketu conjunct another planet',
    taglineHi: 'केतु + सूर्य/चंद्र/… - युति का संदर्भ।',
    taglineEn: 'Ketu with Sun, Moon, etc. - conjunction context.',
    image: '/schools/parashari/devta/ketu.png',
    imageAltHi: 'केतु युति का चित्र',
    imageAltEn: 'Illustration of Ketu conjunctions',
  },
  {
    id: 'my-readings-sun-conjunctions',
    legacyId: 'my-observations-pause-25',
    hi: 'सूर्य की ग्रह युतियां',
    en: 'Sun conjunct another planet',
    titleHi: 'सूर्य की ग्रह युतियां',
    titleEn: 'Sun conjunct another planet',
    taglineHi: 'सूर्य + चंद्र/मंगल/… - युति का संदर्भ और उपाय।',
    taglineEn: 'Sun with Moon, Mars, etc. - conjunction context and remedies.',
    image: '/schools/parashari/devta/surya.png',
    imageAltHi: 'सूर्य युति का चित्र',
    imageAltEn: 'Illustration of Sun conjunctions',
  },
  {
    id: 'my-readings-moon-conjunctions',
    legacyId: 'my-observations-pause-26',
    hi: 'चंद्र की ग्रह युतियां',
    en: 'Moon conjunct another planet',
    titleHi: 'चंद्र की ग्रह युतियां',
    titleEn: 'Moon conjunct another planet',
    taglineHi: 'चंद्र + सूर्य/मंगल/… - मन पर युति का असर।',
    taglineEn: 'Moon with Sun, Mars, etc. - how conjunctions colour the mind.',
    image: '/schools/parashari/devta/moon.png',
    imageAltHi: 'चंद्र युति का चित्र',
    imageAltEn: 'Illustration of Moon conjunctions',
  },
  {
    id: 'my-readings-mars-conjunctions',
    legacyId: 'my-observations-pause-27',
    hi: 'मंगल की ग्रह युतियां',
    en: 'Mars conjunct another planet',
    titleHi: 'मंगल की ग्रह युतियां',
    titleEn: 'Mars conjunct another planet',
    taglineHi: 'मंगल + सूर्य/चंद्र/… - ऊर्जा और युति।',
    taglineEn: 'Mars with Sun, Moon, etc. - energy and conjunction patterns.',
    image: '/schools/parashari/devta/mars.png',
    imageAltHi: 'मंगल युति का चित्र',
    imageAltEn: 'Illustration of Mars conjunctions',
  },
  {
    id: 'my-readings-mercury-conjunctions',
    legacyId: 'my-observations-pause-28',
    hi: 'बुध की ग्रह युतियां',
    en: 'Mercury conjunct another planet',
    titleHi: 'बुध की ग्रह युतियां',
    titleEn: 'Mercury conjunct another planet',
    taglineHi: 'बुध + सूर्य/चंद्र/… - बुद्धि और वाणी पर युति।',
    taglineEn: 'Mercury with Sun, Moon, etc. - intellect and speech under conjunction.',
    image: '/schools/parashari/devta/mercury.png',
    imageAltHi: 'बुध युति का चित्र',
    imageAltEn: 'Illustration of Mercury conjunctions',
  },
  {
    id: 'my-readings-jupiter-conjunctions',
    legacyId: 'my-observations-pause-29',
    hi: 'गुरु की ग्रह युतियां',
    en: 'Jupiter conjunct another planet',
    titleHi: 'गुरु की ग्रह युतियां',
    titleEn: 'Jupiter conjunct another planet',
    taglineHi: 'गुरु + सूर्य/चंद्र/… - ज्ञान और विस्तार की युति।',
    taglineEn: 'Jupiter with Sun, Moon, etc. - wisdom and expansion in conjunction.',
    image: '/schools/parashari/devta/jupiter.png',
    imageAltHi: 'गुरु युति का चित्र',
    imageAltEn: 'Illustration of Jupiter conjunctions',
  },
  {
    id: 'my-readings-venus-conjunctions',
    legacyId: 'my-observations-pause-30',
    hi: 'शुक्र की ग्रह युतियां',
    en: 'Venus conjunct another planet',
    titleHi: 'शुक्र की ग्रह युतियां',
    titleEn: 'Venus conjunct another planet',
    taglineHi: 'शुक्र + सूर्य/चंद्र/… - प्रेम, कला और युति।',
    taglineEn: 'Venus with Sun, Moon, etc. - love, art, and conjunction tone.',
    image: '/schools/parashari/devta/venus.png',
    imageAltHi: 'शुक्र युति का चित्र',
    imageAltEn: 'Illustration of Venus conjunctions',
  },
  {
    id: 'my-readings-saturn-conjunctions',
    legacyId: 'my-observations-pause-31',
    hi: 'शनि की ग्रह युतियां',
    en: 'Saturn conjunct another planet',
    titleHi: 'शनि की ग्रह युतियां',
    titleEn: 'Saturn conjunct another planet',
    taglineHi: 'शनि + सूर्य/चंद्र/… - अनुशासन, कर्म और युति।',
    taglineEn: 'Saturn with Sun, Moon, etc. - discipline, karma, and conjunction.',
    image: '/schools/parashari/devta/saturn.png',
    imageAltHi: 'शनि युति का चित्र',
    imageAltEn: 'Illustration of Saturn conjunctions',
  },
  {
    id: 'my-readings-rahu-conjunctions',
    legacyId: 'my-observations-pause-32',
    hi: 'राहु की ग्रह युतियां',
    en: 'Rahu conjunct another planet',
    titleHi: 'राहु की ग्रह युतियां',
    titleEn: 'Rahu conjunct another planet',
    taglineHi: 'राहु + सूर्य/चंद्र/… - obsession, foreign pull और युति।',
    taglineEn: 'Rahu with Sun, Moon, etc. - obsession, foreign pull, and conjunction.',
    image: '/schools/parashari/devta/rahu.png',
    imageAltHi: 'राहु युति का चित्र',
    imageAltEn: 'Illustration of Rahu conjunctions',
  },
  {
    id: 'my-readings-eighth-lord-sign',
    legacyId: 'my-observations-pause-17',
    hi: 'अष्टमेश किस राशि में',
    en: '8th lord by sign',
    titleHi: 'अष्टमेश किस राशि में',
    titleEn: '8th lord by sign',
    taglineHi: '8वाँ स्वामी की राशि - परिवर्तन का स्वर।',
    taglineEn: '8th lord’s sign - the tone of transformation.',
    image: '/schools/parashari/devta/saturn.png',
    imageAltHi: 'अष्टमेश का चित्र',
    imageAltEn: 'Illustration of the 8th lord',
  },
  {
    id: 'my-readings-arudha-lagna',
    legacyId: 'reading-charts-arudha-lagna',
    hi: 'आरूढ लग्न (जैमिनी पद्धति)',
    en: 'Arudha Lagna (Jaimini)',
    titleHi: 'आरूढ लग्न (जैमिनी पद्धति)',
    titleEn: 'Arudha Lagna (Jaimini method)',
    taglineHi: 'लग्न से अलग - समाज की नज़र में आपकी छवि और प्रतिष्ठा।',
    taglineEn: 'Beyond lagna - social image, reputation, and how the world reads you.',
    image: '/schools/parashari/devta/jupiter.png',
    imageAltHi: 'आरूढ लग्न का चित्र',
    imageAltEn: 'Illustration of Arudha Lagna',
  },
  {
    id: 'my-readings-jupiter-lesser-rules',
    legacyId: 'my-observations-pause-18',
    hi: 'गुरु के 9 कम-सीखे नियम',
    en: '9 lesser-taught Jupiter notes',
    titleHi: 'गुरु के 9 कम-सीखे नियम',
    titleEn: '9 lesser-taught Jupiter notes',
    taglineHi: 'गुरु के बारे में कम चर्चित नौ बातें।',
    taglineEn: 'Nine Jupiter points that rarely get discussed.',
    image: '/schools/parashari/devta/jupiter.png',
    imageAltHi: 'गुरु का चित्र',
    imageAltEn: 'Illustration of Jupiter',
  },
  {
    id: 'my-readings-kendradhipati-doshas',
    legacyId: 'my-observations-pause-19',
    hi: 'दोष समझ (केंद्राधिपति)',
    en: 'Kendradhipati & major doshas',
    titleHi: 'दोष समझ (केंद्राधिपति + अन्य प्रमुख दोष)',
    titleEn: 'Kendradhipati & major doshas',
    taglineHi: 'केंद्राधिपति और अन्य दोष - नाम से नहीं; लग्न, स्वामी और पूरी कुंडली देखकर समझें।',
    taglineEn: 'Kendradhipati and other doshas - read lagna, lords, and the full chart, not just the label.',
  },
  {
    id: 'my-readings-paap-graha-sthana',
    legacyId: 'my-observations-pause-20',
    hi: 'पाप ग्रह व पाप स्थान',
    en: 'Paap graha & paap sthana',
    titleHi: 'पाप ग्रह व पाप स्थान',
    titleEn: 'Paap graha & paap sthana',
    taglineHi: 'पाप ग्रह और पाप स्थान - चार्ट पढ़ने के व्यावहारिक संकेत।',
    taglineEn: 'Paap graha and paap sthana - practical chart-reading notes.',
  },
  {
    id: 'my-readings-daily-life-mantras',
    legacyId: 'my-observations-pause-21',
    hi: 'दिन के 7 संस्कार-मंत्र',
    en: '7 daily life mantras',
    titleHi: 'दिन के 7 संस्कार-मंत्र',
    titleEn: 'Seven daily life mantras',
    taglineHi: 'जागने से सोने तक - छोटे श्लोक, बड़ा भाव।',
    taglineEn: 'From waking to sleep - small verses, large intention.',
    image: '/schools/parashari/devta/sun.png',
    imageAltHi: 'प्रातः सूर्य का चित्र',
    imageAltEn: 'Illustration of the morning sun',
  },
  {
    id: 'my-readings-rahu-seven-signs',
    legacyId: 'my-observations-pause-22',
    hi: 'राहु के 7 जीवन-पैटर्न',
    en: "Rahu's 7 life patterns",
    titleHi: 'सात राहु-पैटर्न जो शायद आप जी रहे हैं',
    titleEn: 'Seven Rahu patterns you may be living',
    taglineHi: 'जो महत्वाकांक्षा या स्वभाव लगे, वह राहु का पाठ हो सकता है - सात दर्पण और हर एक का व्यावहारिक उपाय।',
    taglineEn: 'What feels like ambition or personality may be Rahu\'s lesson - seven mirrors and a practical response for each.',
    image: '/schools/parashari/devta/rahu.png',
    imageAltHi: 'राहु का चित्र',
    imageAltEn: 'Illustration of Rahu',
  },
  {
    id: 'my-readings-western-vedic',
    legacyId: 'intro-western-vedic',
    hi: 'पश्चिमी बनाम वैदिक',
    en: 'West vs Vedic',
    titleHi: 'पाश्चात्य बनाम वैदिक ज्योतिष',
    titleEn: 'Western vs Vedic Astrology',
    taglineHi: 'दो परंपराएँ - गणना, दृष्टिकोण और फलादेश में कैसे अलग हैं।',
    taglineEn: 'Two traditions - how they differ in calculation, outlook, and prediction.',
    image: '/schools/parashari/devta/moon.png',
    imageAltHi: 'पश्चिमी और वैदिक ज्योतिष का चित्र',
    imageAltEn: 'Illustration of Western and Vedic astrology',
  },
  {
    id: 'my-readings-shruti-vedangas',
    legacyId: 'prarambh-shruti-vedangas',
    hi: 'श्रुति और वेदांग',
    en: 'Shruti & Vedangas',
    titleHi: 'श्रुति और छः वेदांग',
    titleEn: 'Shruti and the six Vedangas',
    taglineHi: 'ज्योतिष वैदिक ज्ञान-वृक्ष का अंग है - अलग से चमत्कारी ऐप नहीं।',
    taglineEn: 'Jyotish sits inside the Vedic knowledge tree - not as a random “prediction app.”',
    image: '/schools/parashari/assets/animations/planets/Sun.gif',
    imageAltHi: 'श्रुति और वेदांग का चित्र',
    imageAltEn: 'Illustration of Shruti and Vedangas',
  },
  {
    id: 'my-readings-surya-siddhanta-mahayuga',
    legacyId: 'my-observations-pause-23',
    hi: 'सूर्य सिद्धान्त: महायुग',
    en: 'Surya Siddhanta Mahayuga',
    titleHi: 'सूर्य सिद्धान्त: महायुग और नवग्रह-परिक्रमाएँ',
    titleEn: 'Mahayuga & Planetary Orbits in Surya Siddhanta',
    taglineHi: 'हजारों वर्ष पहले की गणना - चंद्र, गुरु, शनि और सभी ग्रह - आधुनिक खगोल से मेल खाती है।',
    taglineEn: 'Calculations from millennia ago - Moon, Jupiter, Saturn, and all planets - still match modern astronomy.',
    image: '/schools/parashari/devta/surya.png',
    imageAltHi: 'सूर्य का चित्र',
    imageAltEn: 'Illustration of Surya',
  },
  {
    id: 'my-readings-kalapurusha-body-map',
    legacyId: 'my-observations-pause-24',
    hi: 'कालपुरुष · शरीर नक्शा',
    en: 'Kalapurusha body map',
    titleHi: 'कालपुरुष · शरीर का राशि-नक्शा',
    titleEn: 'Kalapurusha · the body-zodiac map',
    taglineHi: 'बारह राशियाँ, बारह अंग - ग्रह जहाँ बैठे, वह शरीर-क्षेत्र देखें।',
    taglineEn: 'Twelve signs, twelve zones - where a planet sits, that body part may speak.',
    image: '/schools/parashari/assets/kalpurush.png',
    imageAltHi: 'कालपुरुष मंडल - बारह राशियाँ और शरीर-अंग',
    imageAltEn: 'Kalapurusha mandala - twelve signs on the cosmic body',
  },
  {
    id: 'my-readings-karaka-from-reference',
    legacyId: 'my-observations-pause-33',
    hi: 'कारक से भी पढ़ें',
    en: 'Read from the Karaka too',
    titleHi: 'लग्न के साथ कारक-दृष्टि - दोहरी पठन',
    titleEn: 'Lagna + Karaka dual reading',
    taglineHi: 'वही भाव, दो reference - लग्न से structure, कारक से गहरा अर्थ।',
    taglineEn: 'Same house, two reference points - structure from Lagna, depth from the Karaka.',
    image: '/schools/parashari/devta/jupiter.png',
    imageAltHi: 'कारक और लग्न - दोहरी चार्ट-दृष्टि',
    imageAltEn: 'Karaka and Lagna dual chart reading',
  },
];

export const MY_READINGS_TOPIC_BY_ID = Object.fromEntries(
  MY_READINGS_TOPICS.map((t) => [t.id, { ...t, lessonCode: t.id }])
);

export const MY_READINGS_LEGACY_ID_ALIASES = Object.fromEntries(
  MY_READINGS_TOPICS.map((t) => [t.legacyId, t.id])
);

/** Migrated Abhyas / chart lessons whose quiz bank rows still tag the legacy topic id. */
export const MY_READINGS_QUIZ_LEGACY_TOPIC_IDS = Object.fromEntries(
  MY_READINGS_TOPICS.filter((t) => t.legacyId && !t.legacyId.startsWith('my-observations-')).map((t) => [
    t.id,
    t.legacyId,
  ]),
);

/**
 * Stable lesson code for progress, bookmarks, and highlights.
 * Survives syllabus renumbering; legacy pause URLs resolve here too.
 * @param {string | null | undefined} topicId
 */
export function getMyReadingsLessonCode(topicId) {
  if (!topicId) return topicId;
  if (MY_READINGS_TOPIC_BY_ID[topicId]) return topicId;
  return MY_READINGS_LEGACY_ID_ALIASES[topicId] ?? topicId;
}

/** Topics also listed under Reading Charts (stable codes, not serial pause numbers). */
export const MY_READINGS_READING_CHART_TOPIC_IDS = [
  'my-readings-kendradhipati-doshas',
  'my-readings-paap-graha-sthana',
];

/** Marga tab rows for the my-observations group. */
export const MY_READINGS_MARGA_TABS = MY_READINGS_TOPICS.filter(
  (t) => !MY_READINGS_READING_CHART_TOPIC_IDS.includes(t.id)
).map((t) => ({ id: t.id, hi: t.hi, en: t.en }));

/** @param {string} topicId */
export function getMyReadingsTopicMeta(topicId) {
  const code = getMyReadingsLessonCode(topicId);
  return MY_READINGS_TOPIC_BY_ID[code] ?? null;
}

/** @param {string} topicId */
export function isMyReadingsTopicId(topicId) {
  const code = getMyReadingsLessonCode(topicId);
  return Boolean(code && MY_READINGS_TOPIC_BY_ID[code]);
}
